module.exports = __webpack_public_path__ + "img/digital04_mo.c5bbf6b9.jpg";